import React, { Component } from "react";

export class ServicesCard extends Component {
  render() {
    let service = this.props.data;
    console.log("service", service);
    return (
      <div className="ui two column stackable grid very relaxed padded">
        <div className="ui column ">
          <a href={service.href} target="_blank" rel="noreferrer">
            <img
              className="ui image big centered rounded"
              id="serviceImage"
              alt={"image for " + service.name}
              src={service.img}
            />
          </a>
        </div>
        <div
          className="ui column center aligned relaxed"
          style={{ alignSelf: "center", fontFamily: "monospace" }}
        >
          <div className="content centered">
            <span className="ui text big" style={{ color: "gold" }}>
              {service?.name}
            </span>
            <div
              className="ui bulleted list huge relaxed "
              style={{ color: "white" }}
            >
              <div className="item">{service.key}</div>
              <div className="item">{service.key2}</div>
              <div className="item">{service.key3}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ServicesCard;
